var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinehub(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 50",
    style: {
      enableBackground: "new 0 0 120 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#A5A8B6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 19.5,
    className: "st0",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "89.8,10 89.8,16.2 85.8,19.5 82.8,19.5 82.8,23.4 86.7,23.4 86.7,20.8 90.3,17.8 97.6,17.8 97.6,10  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.7,15.9v-3.5c0-0.1-0.1-0.2-0.2-0.2h-5.2c-0.1,0-0.2,0.1-0.2,0.2v5.2c0,0.1,0.1,0.2,0.2,0.2h3.2L87.7,15.9z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "74.9,27.3 74.9,31.9 70.6,31.9 70.6,27.3 66.7,27.3 66.7,39.8 70.6,39.8 70.6,34.9 74.9,34.9  74.9,39.8 78.8,39.8 78.8,27.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.7,
    y: 27.3,
    className: "st0",
    width: 3.9,
    height: 12.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "52.1,27.3 52.1,39.8 62.8,39.8 62.8,36.9 55.9,36.9 55.9,35.2 62.3,35.2 62.3,32.1 55.9,32.1  55.9,30.2 62.8,30.2 62.8,27.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.9,34.5c0,4-2.6,5.5-6.1,5.5s-6-1.6-6-5.5v-7.2h3.9v7.2c0,1.5,0.7,2.5,2.2,2.5s2.1-0.9,2.1-2.5v-7.2h3.9 V34.5L94.9,34.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.6,35.8c0,2.6-1.7,4-5.2,4h-6.6V27.3h6.7c3.4,0,4.8,1.2,4.8,3.3c0,1.4-0.7,2-1.7,2.5 C109.9,33.5,110.6,34.4,110.6,35.8 M106.5,31c0-0.6-0.3-1-1.2-1h-2.9v2h2.9C106.2,32,106.5,31.6,106.5,31 M106.9,35.8 c0-0.7-0.5-1.2-1.4-1.2h-3V37h3C106.4,37.1,106.9,36.6,106.9,35.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.4,27.3h3.3l5.3,6.6v-6.6h3.5v12.5h-3.1L41,33v6.9h-3.5L37.4,27.3L37.4,27.3z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "24.6,27.4 21,27.4 21,27.4 21,27.5 17.4,32.1 15.2,29.2 13.8,27.4 13.8,27.4 10.3,27.4 9.4,27.4  9.4,39.9 13.3,39.9 13.3,33.2 15,35.4 15.8,36.5 17,38 17.4,38.5 17.8,38 19,36.5 19.9,35.4 21.6,33.1 21.6,39.9 25.5,39.9  25.5,27.4  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinehub);
export default __webpack_public_path__ + "static/media/minehub.e7cf11e772ccb29d68d9f7b74f98f0f3.svg";
export { ForwardRef as ReactComponent };